import React from "react"
import CheckboxField from "./checkbox_field"
import { quoteCalculations, formatNumber } from "./helpers"

// Deposit ("acompte") block on the quote form: a checkbox to print the clause
// on the PDF + an editable percentage + a live preview of the sentence with the
// computed amount (% × total incl. tax). Only shown when the account enabled
// "Calculer un acompte".
export default class Deposit extends React.Component {
  render() {
    const { quote, replaceQuote } = this.props
    if (!quote.deposit_available) return null

    const labels = quote.deposit_labels || {}
    const pct    = parseInt(String(quote.deposit_percentage).replace(",", "."), 10) || 0
    const total  = quoteCalculations(quote).total || 0
    const amount = total * pct / 100

    const pctText    = String(pct)
    const amountText = `${formatNumber(amount)} ${quote.currency_symbol || ""}`.trim()
    const sentence   = String(quote.deposit_sentence || "")
      .replace(/\{pourcentage\}/g, pctText)
      .replace(/\{montant\}/g, amountText)

    return (
      <div className="deposit-block" style={{ background: "#f8fafc", border: "1px solid #e2e8f0", borderRadius: 8, padding: 16 }}>
        <div className="d-flex align-items-center justify-content-between flex-wrap" style={{ gap: 12 }}>
          <strong>{labels.title || "Acompte"}</strong>
          <CheckboxField
            checked={quote.show_deposit}
            onChange={() => replaceQuote({ ...quote, show_deposit: !quote.show_deposit })}
            name="quote[show_deposit]"
            label={labels.show}
            index="show_deposit"
          />
        </div>

        <div className="d-flex align-items-center" style={{ gap: 8, marginTop: 10 }}>
          <label className="control-label mb-0">{labels.percentage}</label>
          <input
            type="number"
            min="0"
            max="100"
            step="1"
            className="form-control"
            style={{ maxWidth: 130 }}
            name="quote[deposit_percentage]"
            value={quote.deposit_percentage == null ? "" : quote.deposit_percentage}
            onChange={e => {
              let v = e.target.value
              if (v !== "") v = Math.max(0, Math.min(100, Math.round(parseFloat(v) || 0)))
              replaceQuote({ ...quote, deposit_percentage: v })
            }}
          />
        </div>

        <p className="text-muted mb-0" style={{ marginTop: 10, fontStyle: "italic" }}>{sentence}</p>
      </div>
    )
  }
}
